import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "root"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "moveAniDiv"
}, null, -1);

const _hoisted_3 = {
  key: 0,
  id: "copyBox"
};
const _hoisted_4 = {
  class: "context",
  id: "context"
};
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = {
  class: "year"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("换一首");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, $setup.posList.list ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.posList.list, (txt, key) => {
    return _openBlock(), _createElementBlock("span", {
      key: key,
      style: _normalizeStyle([{}, {
        'left': txt.curX + 'px',
        'top': txt.curY + 'px',
        'position': 'absolute'
      }])
    }, _toDisplayString(txt.value), 5);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("h2", null, _toDisplayString(_ctx.title), 1), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.name), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.year), 1)]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.text, (txt, key) => {
    return _openBlock(), _createElementBlock("p", {
      key: key
    }, _toDisplayString(txt), 1);
  }), 128))])])]), _createVNode(_component_el_button, {
    class: "bottom",
    type: "primary",
    onClick: _cache[0] || (_cache[0] = $event => $setup.get_random_one())
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  })], 64);
}